"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverTriggerWrapperStyle = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

var PopoverTriggerWrapperStyle = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "esxgtk70"
})(function (_ref) {
  var verticalAlign = _ref.verticalAlign;
  return "\n  position: relative;\n  display: inline-block;\n\n  ".concat(!!verticalAlign ? "vertical-align: ".concat(verticalAlign, ";") : '', "\n\n  :focus {\n    outline: none;\n  }\n");
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BvcG92ZXItbGVnYWN5L1BvcG92ZXJUcmlnZ2VyV3JhcHBlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJMEMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvcG9wb3Zlci1sZWdhY3kvUG9wb3ZlclRyaWdnZXJXcmFwcGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBjb25zdCBQb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZSA9IHN0eWxlZCgnZGl2JykoXG4gICh7IHZlcnRpY2FsQWxpZ24gfSkgPT4gYFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcblxuICAkeyEhdmVydGljYWxBbGlnbiA/IGB2ZXJ0aWNhbC1hbGlnbjogJHt2ZXJ0aWNhbEFsaWdufTtgIDogJyd9XG5cbiAgOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICB9XG5gXG4pO1xuXG5Qb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZS5kaXNwbGF5TmFtZSA9ICdQb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZSc7XG5Qb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZS5wcm9wVHlwZXMgPSB7fTtcblxuY29uc3QgaXNGdW5jdGlvbiA9IGZ1bmMgPT4gdHlwZW9mIGZ1bmMgPT09ICdmdW5jdGlvbic7XG5cbmNvbnN0IGNoZWNrSWZGb2N1c0lzTGVhdmluZyA9IG9uRm9jdXNMZWF2ZSA9PiBldmVudCA9PiB7XG4gIGNvbnN0IHsgY3VycmVudFRhcmdldCwgcmVsYXRlZFRhcmdldCB9ID0gZXZlbnQ7XG5cbiAgaWYgKCFjdXJyZW50VGFyZ2V0LmNvbnRhaW5zKHJlbGF0ZWRUYXJnZXQpKSB7XG4gICAgb25Gb2N1c0xlYXZlKGV2ZW50KTtcbiAgfVxufTtcblxuY29uc3QgUG9wb3ZlclRyaWdnZXJXcmFwcGVyID0gKHsgY2hpbGRyZW4sIG9uRm9jdXNMZWF2ZSwgdmVydGljYWxBbGlnbiB9KSA9PiAoXG4gIDxQb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZVxuICAgIHZlcnRpY2FsQWxpZ249e3ZlcnRpY2FsQWxpZ259XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIG9uQmx1cj17XG4gICAgICBpc0Z1bmN0aW9uKG9uRm9jdXNMZWF2ZSkgPyBjaGVja0lmRm9jdXNJc0xlYXZpbmcob25Gb2N1c0xlYXZlKSA6IG51bGxcbiAgICB9PlxuICAgIHtjaGlsZHJlbn1cbiAgPC9Qb3BvdmVyVHJpZ2dlcldyYXBwZXJTdHlsZT5cbik7XG5cblBvcG92ZXJUcmlnZ2VyV3JhcHBlci5kaXNwbGF5TmFtZSA9ICdQb3BvdmVyV3JhcHBlcic7XG5Qb3BvdmVyVHJpZ2dlcldyYXBwZXIucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUsXG4gIG9uRm9jdXNMZWF2ZTogUHJvcFR5cGVzLmZ1bmNcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBvcG92ZXJUcmlnZ2VyV3JhcHBlcjtcbiJdfQ== */");
exports.PopoverTriggerWrapperStyle = PopoverTriggerWrapperStyle;
PopoverTriggerWrapperStyle.displayName = 'PopoverTriggerWrapperStyle';
PopoverTriggerWrapperStyle.propTypes = {};

var isFunction = function isFunction(func) {
  return typeof func === 'function';
};

var checkIfFocusIsLeaving = function checkIfFocusIsLeaving(onFocusLeave) {
  return function (event) {
    var currentTarget = event.currentTarget,
        relatedTarget = event.relatedTarget;

    if (!currentTarget.contains(relatedTarget)) {
      onFocusLeave(event);
    }
  };
};

var PopoverTriggerWrapper = function PopoverTriggerWrapper(_ref2) {
  var children = _ref2.children,
      onFocusLeave = _ref2.onFocusLeave,
      verticalAlign = _ref2.verticalAlign;
  return (0, _core.jsx)(PopoverTriggerWrapperStyle, {
    verticalAlign: verticalAlign,
    tabIndex: -1,
    onBlur: isFunction(onFocusLeave) ? checkIfFocusIsLeaving(onFocusLeave) : null
  }, children);
};

PopoverTriggerWrapper.displayName = 'PopoverWrapper';
PopoverTriggerWrapper.propTypes = {
  children: _propTypes.default.node,
  onFocusLeave: _propTypes.default.func
};
var _default = PopoverTriggerWrapper;
exports.default = _default;